import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useLmsMe, hasAnyRole, type LmsRole } from './roles';

type Props = {
  roles: LmsRole[];
  children: ReactNode;
  // Куда редиректить при отсутствии прав. По умолчанию — /403.
  redirectTo?: string;
};

// RequireLmsRole — серверный бэкенд всё равно вернёт 403, но мы делаем UX
// дружелюбнее: при переходе по прямому URL без нужной роли редиректим
// не в «страницу ошибки», а в 403. Во время загрузки /lms/me рендерим skeleton.
export function RequireLmsRole({ roles, children, redirectTo = '/403' }: Props) {
  const { data: me, isLoading, isError } = useLmsMe();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-text-secondary">
        Проверяем права доступа…
      </div>
    );
  }
  if (isError) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAnyRole(me?.roles, ...roles)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
